import React from 'react'
import Div from '@jarvis.oddle/core/components/Div'
import { H3 } from '@jarvis.oddle/core/components/Typo'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import richTextHtmlParser from '@jarvis.oddle/core/components/TextEditor/parser'

const CustomText = ({
  settings
}: {
  settings: {
    bodyText: string
    headingsText: string
  }
}): JSX.Element => {
  const bodyText = richTextHtmlParser(settings.bodyText, { normalised: true })
  return (
    <Div>
      <H3 normalised marginBottom={marginSizes.small} bold>
        {settings.headingsText}
      </H3>
      {bodyText}
    </Div>
  )
}

export default CustomText
